<!-- <div *ngIf="isModalOpen" class="modal" tabindex="-1" role="dialog" id="serviceModal">
</div> -->



<div class="modal-header">
  <h5 class="modal-title">Add File</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">

  <div class="row">
    <div class="col-md-12">
      <label for="displayName">Display Name</label>
      <input type="text" name="displayName" id="displayName" class="form-control"
        [(ngModel)]="uploadDocumentFile.displayName" />
    </div>
  </div>

  <div class="form-group mt-3">
    <label for="file">File</label>
    <input type="file" name="file" id="file" class="form-control"
      [ngClass]="{ 'is-invalid':this.uploadDocumentFile.file==null && submitted }" (change)="onFileChange($event)"
      autofocus />
    <div class="text-danger" *ngIf="this.uploadDocumentFile?.file==null && submitted">
      Please select file.
    </div>
  </div>

  <p *ngIf="allowedFileTypes?.length > 0" class="text-info">
    Allowed Image Types are: {{ allowedFileTypes.join(', ') }}
  </p>

  <div *ngIf="allowedDocumentTypes?.length > 0">
    <p class="text-info">Allowed Document Types are: {{ allowedDocumentTypes?.join(', ') }}</p>
  </div>

  <div *ngIf="uploadService?.filePreview">
    <img [src]="localimageview" style="width: 150px; height: 130px" />
  </div>

  <h5 class="text-danger" *ngIf="fileError">The file type is invalid.</h5>

</div>

<!-- Modal Footer -->
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary" (click)="close()">
    {{ "Close"| translate }}
  </button>
  <!-- <button class="btn btn-primary" (click)="save()" [disabled]="saveButtonDisabled">Save</button> saveButtonDisabled -->
  <button class="btn btn-primary" type="button" [disabled]="loading" (click)="save()" [ngClass]="{loading: loading}">
    <div class="btn-spinner float-left" *ngIf="loading"></div>
    <span *ngIf="!loading">
      Save
    </span>
    <span *ngIf="loading">saving...</span>
  </button>
</div>





<!-- <div class="modal-dialog" role="document">
  <div class="modal-content">

    <div class="modal-header">
      <h3 class="modal-title">Add File</h3>
      <button type="button" class="close" aria-label="Close" (click)="isModalOpen = false">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <div class="row">
        <div class="col-md-12 form-floating">
          <input
            type="text"
            name="displayName"
            id="displayName"
            class="form-control"
            [(ngModel)]="uploadDocumentFile.displayName"
            placeholder="Display Name"
          />
          <label for="displayName">Display Name</label>
        </div>
      </div>

      <div class="form-group mt-3">
        <label for="file">File</label>
        <input
          type="file"
          name="file"
          id="file"
          class="form-control"
          (change)="onFileChange($event)"
          autofocus
        />
      </div>

      <p *ngIf="allowedFileTypes.length > 0" class="text-info">
        Allowed Image Types are: {{ allowedFileTypes.join(', ') }}
      </p>

      <div *ngIf="allowedDocumentTypes.length > 0">
        <p class="text-info">Allowed Document Types are: {{ allowedDocumentTypes.join(', ') }}</p>
      </div>

      <div *ngIf="uploadService.filePreview">
        <img [src]="uploadService.imageUrl" style="width: 150px; height: 130px" />
      </div>

      <h5 class="text-danger" *ngIf="fileError">The file type is invalid.</h5>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-outline-primary me-2" (click)="isModalOpen = false">CLOSE</button>
      <button class="btn btn-primary" (click)="save()" [disabled]="saveButtonDisabled">SAVE</button>
    </div>
  </div>
</div> -->